import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatSlot } from "../caregiverChat";
import {
  List, Card, Info, Title, Status, Dot, When, Actions, JoinButton, CancelButton,
} from "./styles";

// Margen antes de la hora en el que ya se puede entrar a la sala.
const READY_BEFORE_MS = 10 * 60 * 1000;

/**
 * Estado derivado: "Ready to join" no se guarda en base de datos, sale de
 * comparar la hora de la cita con la actual.
 */
export const consultationTone = (session, now = Date.now()) => {
  if (!session) return null;
  if (session.status === "proposed") return "pending";
  if (session.status === "in_progress") return "ready";
  const startsAt = new Date(session.scheduled_at).getTime();
  return now >= startsAt - READY_BEFORE_MS ? "ready" : "confirmed";
};

/**
 * Lista de videoconsultas vivas, de la más próxima a la más lejana.
 */
const VideoConsultationPanel = ({ sessions = [], onJoin, onCancel, busy, fill = false }) => {
  const { t } = useTranslation();
  const [now, setNow] = useState(Date.now());

  // El paso de "Confirmed" a "Ready to join" depende del reloj, no de un evento.
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(id);
  }, []);

  if (sessions.length === 0) return null;

  return (
    <List $fill={fill}>
      {sessions.map((session, index) => {
        const tone = consultationTone(session, now);
        return (
          <Card key={session.id}>
            <Info>
              {/* Solo la primera lleva rótulo: las demás se leen como continuación */}
              {index === 0 && <Title>{t("consultation.next")}</Title>}
              <Status>
                <Dot $tone={tone} />
                {t(`consultation.status.${tone}`)}
              </Status>
              <When>{formatSlot(session.scheduled_at)}</When>
            </Info>

            <Actions>
              <JoinButton disabled={tone !== "ready" || busy} onClick={() => onJoin(session)}>
                {t("consultation.join")}
              </JoinButton>
              <CancelButton disabled={busy} onClick={() => onCancel(session.id)}>
                {t("consultation.cancel")}
              </CancelButton>
            </Actions>
          </Card>
        );
      })}
    </List>
  );
};

export default VideoConsultationPanel;
